// @ts-nocheck

import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { useViewportContext } from '../../contexts/ViewportContext';
import { querySelector } from '../../DOMElements';
import { __ } from '../../i18n/l10n';
import QRScannerContainer from '../QRScanner/QRScannerContainer';
import WinaLoader from '../WinaLoader';

const HEADER_HEIGHT = 4;

const Wrapper = styled.div``;

const Header = styled.div`
  background: black;
  color: white;
  height: ${HEADER_HEIGHT}em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'BettingYantramanav';
  font-weight: 500;
`;

const Title = styled.div`
  font-size: 1.5em;
`;

const Subtitle = styled.div`
  font-size: 1.1em;
`;

const SQUARE_SIDE_VIEWPORT_WIDTH_RATIO = 0.66;

const StyledQRScannerContainer = styled(QRScannerContainer)`
  ${({ $viewportHeight, $viewportWidth, $navbarHeight, $loading }) => css`
    > section > section {
      /* Wrapper */
      height: calc(${$viewportHeight}px - ${$navbarHeight}px - ${HEADER_HEIGHT}em);

      > div {
        /* Target square */
        ${$loading
          ? css`
              display: none;
            `
          : undefined}
        border: none;

        border-top: calc(
            (
                calc(${$viewportHeight}px - ${$navbarHeight}px - ${HEADER_HEIGHT}em) -
                  ${$viewportWidth * SQUARE_SIDE_VIEWPORT_WIDTH_RATIO}px
              ) / 2
          )
          solid rgba(0, 0, 0, 0.5) !important;
        border-bottom: calc(
            (
                calc(${$viewportHeight}px - ${$navbarHeight}px - ${HEADER_HEIGHT}em) -
                  ${$viewportWidth * SQUARE_SIDE_VIEWPORT_WIDTH_RATIO}px
              ) / 2
          )
          solid rgba(0, 0, 0, 0.5) !important;
        border-left: ${($viewportWidth - $viewportWidth * SQUARE_SIDE_VIEWPORT_WIDTH_RATIO) / 2}px solid
          rgba(0, 0, 0, 0.5) !important;
        border-right: ${($viewportWidth - $viewportWidth * SQUARE_SIDE_VIEWPORT_WIDTH_RATIO) / 2}px solid
          rgba(0, 0, 0, 0.5) !important;
      }

      > video {
        transition: opacity 300ms ease-in-out;
        ${$loading
          ? css`
              opacity: 0;
            `
          : css`
              opacity: 1;
            `}
      }
    }
  `}
`;

const StyledWinaLoader = styled(WinaLoader)`
  ${({ $viewportHeight, $navbarHeight, $loading }) => css`
    position: absolute;
    top: calc(${$viewportHeight / 2}px - ${$navbarHeight / 2}px - ${HEADER_HEIGHT / 2}em);
    left: 0;
    margin: 0;

    ${$loading
      ? undefined
      : css`
          display: none;
        `}
  `}
`;

type QRScannerViewProps = {
  className?: string;
};

const QRScannerView = ({ className = '' }: QRScannerViewProps) => {
  const { width, height, navbarHeight } = useViewportContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const video = querySelector('video');
    const callback = () => {
      setLoading(false);
    };

    if (video) {
      video.addEventListener('canplay', callback);
    }

    return () => {
      video.removeEventListener('canplay', callback);
    };
  }, []);

  return (
    <Wrapper className={className}>
      <Header>
        <Title>{__('Winamax QR code')}</Title>
        <Subtitle>{__('Scan a bonus code')}</Subtitle>
      </Header>

      <StyledQRScannerContainer
        $loading={loading}
        $viewportHeight={height}
        $viewportWidth={width}
        $navbarHeight={navbarHeight}
      />

      <StyledWinaLoader
        $viewportHeight={height}
        $viewportWidth={width}
        $navbarHeight={navbarHeight}
        $loading={loading}
      />
    </Wrapper>
  );
};

export default QRScannerView;
